<template>
    <div class="mx-auto col-lg-4 col-md-6 col-sm-12 header-margin">
        <div class="text-center p-2">
            <h3>{{ $t('account.password.forgot') }}</h3>
        </div>

        <div class="p-2">
            <div>
                <div class="form-group">
                    <label>{{ $t('account.email') }}</label>
                    <input v-model="formData.account" name="account" class="form-control"
                           v-bind:class="{ 'is-invalid': errors.account}"/>
                    <div v-if="errors.account" class="invalid-feedback invalid-errors">{{ $t('errors.' + errors.account) }}</div>
                </div>
                <div v-if="(!errors.account)" class="invalid-errors-hiddens"></div>

                <div class="form-group">
                    <label>{{ $t('account.edit.birthDate') }}</label>
                    <div class="form-group">
                        <DatePicker
                        onpaste="return false"
                        readonly
                        :options = "options"
                        v-model = "formData.birth_date"
                        :class="{ 'is-invalid': errors.birth_date}"
                        class="form-control col-form-label"
                        />
                        <div v-if="errors.birth_date" class="invalid-feedback invalid-errors">{{ $t('errors.' + errors.birth_date) }}</div>
                    </div>
                    <div v-if="(!errors.birth_date)" class="invalid-errors-hiddens"></div>
                </div>
                

                <div class="pt-4 text-center">
                    <button type="button" class="btn btn-primary" :disabled="submitBtnDisabled()" @click="handleOnSubmit()">{{ $t('account.password.reset') }}</button>
                </div>
            </div>

            <div class="pt-2 text-center">
                    <router-link to="/login">{{ $t('auth.btnLogin') }}</router-link>
            </div>

        </div>
    </div>
</template>

<script>
    import UserService from '../../services/UserService';
    import DatePicker from "../../components/DatePicker";
    import languageService from '../../services/LanguageService';

    export default {
        name: 'forgot-password-module',

        data() {
            return {
                errors: this.getDefaultFields(),
                formData: this.getDefaultFields(),
                initDate: this.getDefaultDate(),
                language: '',
                options: {
                    defaultDate: this.getDefaultDate(),
                }
            }
        },
        

        components: {
            DatePicker,
        },

        methods: {
            getDefaultDate() {
                var  date = new Date();
                var  mounth = ("0"+(date.getMonth() + 1)).slice(-2);
                var  date =  ("0"+date.getDate()).slice(-2);
                var  today  = "1970-" + mounth + "-" + date;
                return today;
            },
            getDefaultFields() {
                return {
                    account: '',
                    birth_date: '',
                };
            },

            submitBtnDisabled() {
                return (!this.formData.account);
            },

            async handleOnSubmit() {
                this.errors = this.getDefaultFields();
                this.language = languageService.getCurrentLanguageCode();

                try {
                    await UserService.forgotPassword({
                        account: this.formData.account,
                        birth_date: this.formData.birth_date,
                        language: this.language,
                    });
                    this.$router.push('/forgot-password/sent');
                } catch (err) {
                    if (err.response.data.errors) {
                        err.response.data.errors.forEach(errItem => {
                            if (errItem.field) {
                                this.errors[errItem.field] = errItem.message[0];
                                if (errItem.message[0] === 'USER_TOKEN_DATA_WITHIN_24H') {
                                    this.$router.push('/forgot-password/error?title=changePassword&message=userTokenDataWithin24H');
                                }
                            }
                        })
                    }
                }
            },
        }
    }
</script>

<style scoped>
.hasDatepicker {
    display: block;
    width: 100%;
    height: calc(1.6em + .75rem + 2px);
    padding: .375rem .75rem;
    font-size: .9rem;
    font-weight: 400;
    line-height: 1.6;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: .25rem;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
    .invalid-feedback {
        display: block;
    }
    .form-control[readonly] {
        background-color: #ffffff;
    }
    .form-group {
        margin-bottom: 0px;
    }
    .btn-primary:hover {
        color: #fff !important;
        background-color: #350f71 !important;
        border-color: #300e66 !important;
    }
    /*PC PAD用css*/
    @media screen and (min-width: 479px) { /*ウィンドウ幅が479px以上の場合に適用*/
        .invalid-errors-hiddens{
            visibility:hidden;
            height: 36px;
            margin-top: 4px;
            margin-bottom: 4px;
        }
        .invalid-errors{
            min-height:36px;
            height:auto !important;
            height:36px;
            margin-top: 4px;
            margin-bottom: 4px;
        }
    }
    /*スマホ用css*/
    @media screen and (max-width: 479px) { /*ウィンドウ幅が最大479pxまでの場合に適用*/
        .invalid-errors-hiddens{
            visibility:hidden;
            height: 15px;
            margin-top: 4px;
            margin-bottom: 4px;
        }
        .invalid-errors{
            min-height:10px;
            height:auto !important;
            height:10px;
            margin-top: 5px;
        }
        .col-form-label{
            padding-top: 0px;
        }
        .btn-position{
            padding-top: 10px;
        }
    }
</style>
